import React, { useMemo, useState } from 'react';
import DENTModalOverviewSubButtonsSelection from '../DENTModalOverviewSubButtonsSelection/DENTModalOverviewSubButtonsSelection';
import {
	ToothFracturePosition,
	ToothFractureType,
	ToothPresence,
} from '../../../../graphql/graphql';
import useTooth from '../../Hooks/Tooth/useTooth';
import { find } from 'lodash';

const DENTModalOverviewPathologyFracture = () => {
	const {
		pathology: {
			fractures: { values, setPosition, setSimpleValue },
		},
	} = useTooth();

	const [type, setType] = useState<ToothFractureType>();

	const fracture = useMemo(() => find(values, { type }), [values, type]);

	const handleChangeType = (value: ToothFractureType) => {
		setType(value === type ? undefined : value);
	};

	const togglePositionForType = (value: ToothFracturePosition) => {
		if (!type) return;
		setPosition(type, value);
	};

	const handleChangePulpInvolvement = (value: ToothPresence) => {
		if (!type) return;
		setSimpleValue(type, 'pulpInvolvement', value);
	};

	const rows = [
		{
			shouldHide: false,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.typeCrown',
					isSelected: type === ToothFractureType.Crown,
					onClick: () => handleChangeType(ToothFractureType.Crown),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.typeRoot',
					isSelected: type === ToothFractureType.Root,
					onClick: () => handleChangeType(ToothFractureType.Root),
				},
			],
		},
		{
			shouldHide: !type,
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.positionVertical',
					isSelected:
						fracture?.positions?.includes(ToothFracturePosition.Vertical) ??
						false,
					onClick: () => togglePositionForType(ToothFracturePosition.Vertical),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.positionHorizontal',
					isSelected:
						fracture?.positions?.includes(ToothFracturePosition.Horizontal) ??
						false,
					onClick: () =>
						togglePositionForType(ToothFracturePosition.Horizontal),
				},
			],
		},
		{
			shouldHide: !(fracture?.type && fracture?.positions?.length),
			items: [
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.pulpInvolved',
					isSelected: fracture?.pulpInvolvement === ToothPresence.Yes,
					onClick: () => handleChangePulpInvolvement(ToothPresence.Yes),
				},
				{
					title:
						'patientTreatment.meddiDENT.dentalCross.pathologyModal.fracture.pulpNotInvolved',
					isSelected: fracture?.pulpInvolvement === ToothPresence.No,
					onClick: () => handleChangePulpInvolvement(ToothPresence.No),
				},
			],
		},
	];

	return <DENTModalOverviewSubButtonsSelection rows={rows} />;
};

export default DENTModalOverviewPathologyFracture;
